import './FilterConfigBase.scss';

import { FunctionComponent, memo, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Icons, SearchInputField, Tooltip, TreeFilter } from 'plume-ui';

import cx from 'classnames';

import { Maybe } from '../../../../types';

type LocationFilterConfigProps = {
  filterSelectorContent: React.ReactNode;
  sectionTitle: string;
  searchPlaceholder?: string;
  selectedFilters?: React.ReactNode;
  tableClassName?: string;
  noSelectionMessage?: string;
  definitionTooltip?: string;
  onSearch?: (searchQuery: Maybe<string>) => void;
};

const FilterConfigWrapper: FunctionComponent<LocationFilterConfigProps> = ({
  filterSelectorContent,
  selectedFilters,
  noSelectionMessage,
  tableClassName,
  searchPlaceholder,
  sectionTitle,
  definitionTooltip,
  onSearch,
}) => {
  const { t } = useTranslation();

  const [searchQuery, setSearchQuery] = useState<string>();

  useEffect(() => {
    onSearch?.(searchQuery as string);
  }, [searchQuery, onSearch]);

  return (
    <div className="FilterConfig FilterConfig__body">
      <div className="FilterConfig__gridItem">
        {Boolean(sectionTitle) && (
          <div className="FilterConfig__header">{sectionTitle}</div>
        )}
        <div className="FilterConfig__search">
          <SearchInputField
            id={'locationSearch'}
            rounded
            placeholder={
              searchPlaceholder || t('monitorAdd.filterSearch.locations')
            }
            onKeyUp={(event) =>
              setSearchQuery((event.target as HTMLInputElement).value)
            }
            onChange={(event) =>
              setSearchQuery((event.target as HTMLInputElement).value)
            }
          />
          <div className="FilterConfig__attributeSelector FilterConfig__section">
            <TreeFilter>{filterSelectorContent}</TreeFilter>
          </div>
        </div>
      </div>
      <div className="FilterConfig__gridItem">
        <div className="FilterConfig__header">
          {t('monitorAdd.filterConfigHeaders.definition')}{' '}
          {definitionTooltip && (
            <Tooltip label={definitionTooltip}>
              <Icons.CircleInfoIcon />
            </Tooltip>
          )}
        </div>
        <div className={cx('ConfigTable', tableClassName)}>
          {selectedFilters}
          {!Boolean(selectedFilters) && (
            <div className="FilterItem FilterItem--noSelection">
              {noSelectionMessage || 'Please select attribute.'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(FilterConfigWrapper);
